import { Injectable } from '@angular/core';
import { MonthsDebtsInput, PrettyMonthCut } from 'core/http/lg-logistic-rest-api/Auth/project.service';
import { ReconciliationService } from 'core/http/project';
import moment from 'moment';
import { Observable } from 'rxjs';

@Injectable()
export class MonthsDebtsResolver {
  constructor(private reconciliationService: ReconciliationService) {}

  resolve(): Observable<PrettyMonthCut[]> {
    const today = moment().format('YYYY-MM-DD');
    const sixMonthsAgo = moment()
      .subtract(5, 'months')
      .set('date', 1)
      .format('YYYY-MM-DD');

    const input: MonthsDebtsInput = {
      cutDate: today,
      unloadedFrom: sixMonthsAgo,
      unloadedTo: today,
    };

    return this.reconciliationService.getMonthDebts(input);
  }
}
